import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import "../Dialog.css";

import useAlert from "../../../hooks/useAlert";
import { useForm } from "antd/lib/form/Form";
import { Col, Form, Row, Switch } from "antd";
import { InputText } from "primereact/inputtext";
import { FiSave } from "react-icons/fi";
import { SaveZsyncgl } from "../../../Services/ZsyncglService";

interface Props {
  dialogHeader: string;
  formData: any;
  tableData?: any;
  setTableData?: (items: any) => void;
  tableComfirmDialog?: boolean;
  setTableComfirmDialog?: (bool: boolean) => void;
  mainDialogVisible?: boolean;
  toggleMainDialog: (state: boolean, action: string) => void;
  setMainLoading?: (bool: boolean) => void;
}

export const ZsyncglDialog = (props: Props) => {
  const { toggleAlert } = useAlert();
  const [form] = useForm();

  useEffect(() => {
    form.setFieldsValue(props.formData);
  }, [props.formData]);

  const handleSubmit = async (values: any) => {
    if (props.setMainLoading !== undefined) {
      props.setMainLoading(true);
    }
    const res = await SaveZsyncgl(values);
    if (res) {
      props.toggleMainDialog(false, "save");
      form.resetFields();
      toggleAlert({
        type: "success",
        message: "Success",
        description: "ZSYNCGL saved successfully",
      });
    } else {
      toggleAlert({
        type: "error",
        message: "Error",
        description: "ZSYNCGL not saved",
      });
    }
    if (props.setMainLoading !== undefined) {
      props.setMainLoading(false);
    }
  };

  return (
    <Dialog
      visible={props.mainDialogVisible}
      breakpoints={{}}
      style={{ width: "70vw", borderRadius: "16px" }}
      header={props.dialogHeader}
      modal
      className="p-fluid"
      onHide={() => {
        form.resetFields();
        props.toggleMainDialog(false, "close");
      }}
      draggable={false}
      closable={false}
      blockScroll
    >
      <Form
        form={form}
        name="ZsyncglForm"
        onFinish={handleSubmit}
        labelCol={{ span: 6 }}
        labelAlign="left"
        validateTrigger="onSubmit"
      >
        <Form.Item name="Id" hidden />
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item
              label="GL Account"
              name="GLAccount"
              validateTrigger="onBlur"
              rules={[
                {
                  required: true,
                  message: "Please enter GL Account",
                },
              ]}
            >
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="Name"
              validateTrigger="onBlur"
              rules={[{ required: true, message: "Please enter Name" }]}
            >
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item label="Type" name="Type" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Account KOKJ"
              name="AccountKOKJ"
              initialValue={""}
            >
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item label="Post Key" name="PostKey" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="ANBWA" name="ANBWA" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item label="NEWKO" name="NEWKO" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="NASSETS" name="NASSETS" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item label="ANKL" name="ANKL" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Post Key AA" name="PostKeyAA" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item label="Newko AA" name="NewkoAA" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="ANBWAAA" name="ANBWAAA" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item label="NEWUM" name="NEWUM" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Asset Group" name="assetgroup" initialValue={""}>
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item
              label="Category Group Code"
              name="CategoryGroupCode"
              initialValue={""}
            >
              <InputText maxLength={10} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Is Active"
              name="IsActive"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        <div className="footer-dialog">
          <button
            onClick={() => {
              props.toggleMainDialog(false, "close");
            }}
            className="button-cancle"
          >
            Close
          </button>

          <button className="button-save" type="submit">
            <FiSave />
            Save
          </button>
        </div>
      </Form>
    </Dialog>
  );
};
